/*global google*/

import React, { Component } from 'react';
import { Link, withRouter } from 'react-router-dom';
import Geosuggest from 'react-geosuggest';

import { FormRow, Input, MainBtn, CancelBtn } from '../Common/form/Elements-export';
import { StaticRoutePaths } from '../Common/ClientRoutes';
import { UserRole } from '../Common/UserRole';

import { createCompany } from './epics-companies';
import Svgs from '../Common/Svgs';

import localStorage from '../Common/LocalStorage';
import LocalizedStrings from 'react-localization';
import { translations } from '../Common/Translations';

let strings = new LocalizedStrings(translations);
strings.setLanguage(localStorage.getFromStorage('lang') !== undefined ? localStorage.getFromStorage('lang') : 'en');

class AddCompany extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userRole: localStorage.getFromStorage('role'),
            loadingSpinner: false,
            companyName: '',
            companyAddress: {
                name: '',
                latitude: '',
                longitude: ''
            },
            companyPhone: '',

            validation: {
                companyName: '',
                companyAddress: '',
                latitude: '',
                longitude: '',
                companyPhone: ''
            }
        };
    }

    update = type => e => {
        this.setState({ ...this.state, [type]: e.target.value });
    };

    onSuggestSelect = suggest => {
        if (suggest !== undefined) {
            this.setState({
                ...this.state,
                companyAddress: {
                    name: suggest.label ? suggest.label : '',
                    latitude: (suggest.location && suggest.location.lat) ? suggest.location.lat.toString() : '0.00',
                    longitude: (suggest.location && suggest.location.lat) ? suggest.location.lng.toString() : '0.00'
                }
            });
        }
    };

    cleanSuggest = event => {
        if (event === '') {
            this.setState({
                ...this.state,
                companyAddress: {
                    name: '',
                    latitude: '',
                    longitude: ''
                }
            });
        }
    };

    createCompanyHandler = () => {
        this.setState({
            ...this.state,
            loadingSpinner: true
        });

        createCompany(this.state)
            .then(() => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false
                });
                if (this.state.userRole === UserRole.STORE_OWNER) {
                    this.props.history.push(StaticRoutePaths.INFO_COMPANY);
                } else {
                    this.props.history.push(StaticRoutePaths.COMPANIES);
                }
            })
            .catch(error => {
                this.setState({
                    ...this.state,
                    loadingSpinner: false,
                    validation: {
                        companyName: this.generateErrors(error.body, 'name')
                            .join(' ')
                            .trim(),
                        companyAddress: this.generateErrors(error.body, 'address.name')
                            .join(' ')
                            .trim(),
                        latitude: this.generateErrors(error.body, 'address.latitude')
                            .join(' ')
                            .trim(),
                        longitude: this.generateErrors(error.body, 'address.longitude')
                            .join(' ')
                            .trim(),
                        companyPhone: this.generateErrors(error.body, 'phone')
                            .join(' ')
                            .trim()
                    }
                });
            });
    };

    generateErrors = (errArray, errName) => {
        return errArray.map(singleErr => {
            return singleErr.property_path === errName ? singleErr.message : '';
        });
    };

    showErrors = message => (message === '' ? null : <div className="qf-error-message">{message}</div>);

    addressErrors = (address, latitude, longitude) =>
        (longitude || latitude) !== '' && address === '' ? <div className="qf-error-message">{strings.enter_valid_address}</div> : null;

    cancelCompanyHandler = () => {
        let direction =
            this.state.userRole === UserRole.STORE_OWNER
                ? this.props.history.push(StaticRoutePaths.INFO_COMPANY)
                : this.props.history.push(StaticRoutePaths.COMPANIES);
        return direction;
    };

    render() {
        return (
            <div className="container">
                <div className="row qf-mb-100">
                    <div className="col-1 light-blue-bg text-center pt-3">
                        <span className="qf-page-icon">{Svgs.companies}</span>
                    </div>
                    <div className="col-11 white-bg px-5">
                        <div className="row">
                            <div className="col-9">
                                <h2 className="qf-page-title">
                                    <i className="fa fa-plus-square mr-2" />
                                    {strings.add_new_company}
                                </h2>
                            </div>
                            <div className="col-3 align-self-center text-right">
                                {this.state.userRole === UserRole.STORE_OWNER ? (
                                    <Link to={StaticRoutePaths.INFO_COMPANY} className="qf-back-btn">
                                        <i className="fa fa-chevron-left" />
                                        {strings.back}
                                    </Link>
                                ) : (
                                    <Link to={StaticRoutePaths.COMPANIES} className="qf-back-btn">
                                        <i className="fa fa-chevron-left" />
                                        {strings.back}
                                    </Link>
                                )}
                            </div>
                        </div>

                        <div className="row">
                            <div className="col-12">
                                <hr className="qf-divider-line" />
                            </div>
                        </div>

                        <FormRow>
                            <Input
                                handler={this.update('companyName')}
                                inputType="text"
                                label={`* ${strings.company_name}`}
                                placeholder={strings.company_name}
                                extraClasses="col-sm-12"
                                value={this.state.companyName}
                            />
                            <div className="col-sm-12">{this.showErrors(this.state.validation.companyName)}</div>
                        </FormRow>
                        <FormRow>
                            <div className="formInput col-sm-12 qf-address">
                                <label>
                                    * {strings.address} <span className="qf-small-label-desc">({strings.mailing_purposes_only})</span>
                                    <i className="fa fa-map-marker" aria-hidden="true"/>
                                </label>
                                <Geosuggest
                                    ref={el => (this._geoSuggest = el)}
                                    placeholder={strings.search_places}
                                    initialValue={this.state.companyAddress.name}
                                    onSuggestSelect={this.onSuggestSelect}
                                    onKeyPress={this.onKeyPress}
                                    onBlur={this.cleanSuggest}
                                    location={new google.maps.LatLng(53.558572, 9.9278215)}
                                    radius="20"
                                />
                                <span style={{ fontStyle: 'italic', color: '#858585' }}>{strings.select_address_from_suggest_list}</span>
                            </div>
                            <div className="col-sm-12">{this.showErrors(this.state.validation.companyAddress)}</div>
                            <div className="col-sm-12">
                                {this.addressErrors(
                                    this.state.validation.companyAddress,
                                    this.state.validation.latitude,
                                    this.state.validation.longitude
                                )}
                            </div>
                        </FormRow>
                        <FormRow>
                            <Input
                                handler={this.update('companyPhone')}
                                inputType="text"
                                label={`* ${strings.phone}`}
                                placeholder={strings.work_phone}
                                extraClasses="col-sm-12"
                                value={this.state.companyPhone}
                            />
                            <div className="col-sm-12">{this.showErrors(this.state.validation.companyPhone)}</div>
                        </FormRow>
                        <FormRow>
                            <div className="col-2 offset-8 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="px-5 text-center p-3" />
                                ) : (
                                    <CancelBtn
                                        onclick={this.cancelCompanyHandler}
                                        title={strings.cancel}
                                        extraClasses="qf-gray-btn w-100 mt-4"
                                    />
                                )}
                            </div>

                            <div className="col-2 qf-mb-30">
                                {this.state.loadingSpinner ? (
                                    <div className="px-5 text-center p-3">
                                        <i className="fa fa-spinner fa-spin fa-2x" style={{ color: '#858585' }} />
                                    </div>
                                ) : (
                                    <MainBtn
                                        onclick={this.createCompanyHandler}
                                        title={strings.add_company}
                                        extraClasses="qf-blue-btn w-100 mt-4"
                                    />
                                )}
                            </div>
                        </FormRow>
                    </div>
                </div>
            </div>
        );
    }
}

export default withRouter(AddCompany);



// WEBPACK FOOTER //
// ./src/customModules/Companies/component-add-company.js